import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import * as Scroll from 'react-scroll';
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import venderThumb from "../images/vender-1.svg";
import { useForm } from "react-hook-form";
import profileThumb from "../images/profileThumb.png";
import itemThumb from "../images/itemThumb.svg";
import itemProfile from "../images/itemProfile.svg";
import { loginUser, getTipos, registerUser } from "./API Functions";
import Fade from "react-reveal/Fade";
import $ from 'jquery';
import { Helmet } from 'react-helmet';
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import useMightyMouse from "react-hook-mighty-mouse";
import okkiLanding1 from "../images/okki-landing-1.svg"
import okkiLanding2 from "../images/okki-landing-2.svg"
import okkiLanding3 from "../images/okki-landing-3.svg"
import okkiLanding4 from "../images/okki-landing-4.svg"
import okkiLanding5 from "../images/okki-landing-5.svg"
import okkiLanding6 from "../images/okki-landing-6.svg"
import { hotjar } from 'react-hotjar';


//hotjar.initialize(1991124, 6);

// const getDimensions = ele => {
//   const { height } = ele.getBoundingClientRect();
//   const offsetTop = ele.offsetTop;
//   const offsetBottom = offsetTop + height;

//   return {
//     height,
//     offsetTop,
//     offsetBottom,
//   };
// };

const scrollTo = ele => {
  ele.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

function Julio() {
  const [showText, setShowText] = useState(false);

  const [headerStyle, setHeaderStyle] = useState({
    transition: "all 300ms ease-in",
  });

  const [headerStyle2, setHeaderStyle2] = useState({
    transition: "all 600ms ease-in",
  });

  const [Tipos, setTipos] = useState([]);

  const [Loading, setLoading] = useState(false);
  const [tipo_id, setTipoID] = useState("");
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [nombre_negocio, setNombreNegocio] = useState("");

  const [nombreError, setNombreError] = useState("");
  const [postEmailError, setPostEmailError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [nombre_negocioError, setNombre_negocioError] = useState("");
  const [tipo_idError, setTipoIdError] = useState("");

  const [tiredness, setTiredness] = useState(0);

  const [visibleSection, setVisibleSection] = useState();

  const [isToggled, setToggled] = useState(false);

  const toggleTrueFalse = () => setToggled(!isToggled);


  const headerRef = useRef(null);
  const introRef = useRef(null);
  const formRef = useRef(null);

  const sectionRefs = [
    { section: "Intro", ref: introRef },
    { section: "Form", ref: formRef },
  ];

  const icons = [
    {
      icon: okkiLanding1
    },
    {
      icon: okkiLanding2
    },
    {
      icon: okkiLanding3
    },
    {
      icon: okkiLanding4
    },
    {
      icon: okkiLanding5
    },
    {
      icon: okkiLanding6
    }
  ];

  const [activeIcon, setActiveIcon] = useState(0);

  const randomIcon = e => {
    const len = icons.length;
    setActiveIcon(Math.floor(Math.random() * len));
  };
  useEffect(() => {
    hotjar.initialize('1991124', 6);
    randomIcon();
  }, [])

  useEffect(() => {
    getTipos().then((res) => {
      if (res) {
        setTipos(res);
      }
    });
  }, []);

  function scrollTo() {
    scroller.scrollTo('myScrollToElement', {
      delay: 100,
      duration: 1000,
      smooth: 'easeOutQuad'
    });
  }

  function validateFields() {
    let nombreError = "";
    let emailError = "";
    let nombre_negocioError = "";
    let tipoIdError = "";

    if (nombre == "") {
      nombreError = "Requerido";
    }
    if (email == "") {
      emailError = "Requerido";
    }
    if (nombre_negocio == "") {
      nombre_negocioError = "Requerido";
    }
    if (tipo_id == "") {
      tipoIdError = "Selecciona una opción"
    }

    if (
      nombreError ||
      emailError ||
      nombre_negocioError ||
      tipoIdError
    ) {
      setNombreError(nombreError);
      setEmailError(emailError);
      setNombre_negocioError(nombre_negocioError);
      setTipoIdError(tipoIdError);
      return false;
    } else {
      setNombreError(nombreError);
      setEmailError(emailError);
      setNombre_negocioError(nombre_negocioError);
      setTipoIdError(tipoIdError);
      return true;
    }
  }

  function handleChange(id) {
    setTipoID(id);
  }

  const history = useHistory();

  function handleThanks() {
    window.location.replace("/gracias");
  }

  function handleSubmit() {
    setLoading(true);
    const isValid = validateFields();
    const data = {
      nombre: nombre,
      correo: email,
      apellidos: nombre,
      nombre_negocio: nombre_negocio,
      whatsapp: "",
      envio_id: 2,
      url_negocio: "",
      tipo_id: tipo_id,
      password: "",
      role_name: "user",
      landing: true
    }
    if (isValid) {
      registerUser(data).then((res) => {
        if (res) {
          handleThanks()
        } else {
          setPostEmailError("Este correo ya existe");
        }
      });
    }
    setTimeout(() => {
      setLoading(false);
      setPostEmailError("");
    }, 2000);
  }

  return (
    <div>
      
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PLGBK74" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>
      

      <Helmet>
        <script src="https://embed.small.chat/T01BJC6LV8DG01BTLL2TNY.js" async></script>

      </Helmet>

      <div className={`customLand2 ${isToggled ? "customLand2-bg" : ""}`} id="customLand2">
        <Fade bottom opposite when={!isToggled}>
          <div className={!isToggled ? "customLand2-nav showForm" : "customLand2-nav customLand2-nav2"} ref={headerRef}>
            <div className={`customLand2-navItem ${visibleSection === "Intro" ? "selected" : ""}`}
              className="customLand2-navItem">
              <a target="_blank" href="https://www.instagram.com/okkico/" className="customLand2-navItem-full">Instagram</a>
              <a target="_blank" href="https://www.instagram.com/okkico/" className="customLand2-navItem-responsive">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H24V23.9971H0V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C8.741 0 8.33234 0.0138139 7.05242 0.0722133C5.77516 0.13047 4.90283 0.333343 4.13954 0.630008C3.35044 0.936629 2.68123 1.34695 2.01406 2.01406C1.34695 2.68123 0.936629 3.35044 0.630008 4.13954C0.333343 4.90283 0.13047 5.77516 0.0722133 7.05242C0.0138139 8.33234 0 8.741 0 12C0 15.259 0.0138139 15.6677 0.0722133 16.9476C0.13047 18.2248 0.333343 19.0972 0.630008 19.8605C0.936629 20.6496 1.34695 21.3188 2.01406 21.9859C2.68123 22.6531 3.35044 23.0634 4.13954 23.37C4.90283 23.6667 5.77516 23.8695 7.05242 23.9278C8.33234 23.9862 8.741 24 12 24C15.259 24 15.6677 23.9862 16.9476 23.9278C18.2248 23.8695 19.0972 23.6667 19.8605 23.37C20.6496 23.0634 21.3188 22.6531 21.9859 21.9859C22.6531 21.3188 23.0634 20.6496 23.37 19.8605C23.6667 19.0972 23.8695 18.2248 23.9278 16.9476C23.9862 15.6677 24 15.259 24 12C24 8.741 23.9862 8.33234 23.9278 7.05242C23.8695 5.77516 23.6667 4.90283 23.37 4.13954C23.0634 3.35044 22.6531 2.68123 21.9859 2.01406C21.3188 1.34695 20.6496 0.936629 19.8605 0.630008C19.0972 0.333343 18.2248 0.13047 16.9476 0.0722133C15.6677 0.0138139 15.259 0 12 0ZM12.0004 2.16199C15.2045 2.16199 15.5841 2.17423 16.8494 2.23196C18.0194 2.28531 18.6548 2.4808 19.0776 2.64514C19.6378 2.86283 20.0375 3.12286 20.4574 3.54281C20.8773 3.9627 21.1374 4.36244 21.3551 4.92257C21.5194 5.34542 21.7149 5.98081 21.7682 7.1508C21.826 8.41615 21.8382 8.7957 21.8382 11.9999C21.8382 15.204 21.826 15.5835 21.7682 16.8489C21.7149 18.0188 21.5194 18.6542 21.3551 19.0771C21.1374 19.6372 20.8773 20.037 20.4574 20.4569C20.0375 20.8768 19.6378 21.1368 19.0776 21.3545C18.6548 21.5189 18.0194 21.7143 16.8494 21.7677C15.5842 21.8254 15.2047 21.8377 12.0004 21.8377C8.79601 21.8377 8.41656 21.8254 7.15135 21.7677C5.98136 21.7143 5.34597 21.5189 4.92312 21.3545C4.36299 21.1368 3.96325 20.8768 3.54335 20.4569C3.12346 20.037 2.86338 19.6372 2.64569 19.0771C2.48135 18.6542 2.28586 18.0188 2.23251 16.8489C2.17478 15.5835 2.16254 15.204 2.16254 11.9999C2.16254 8.7957 2.17478 8.41615 2.23251 7.1508C2.28586 5.98081 2.48135 5.34542 2.64569 4.92257C2.86338 4.36244 3.12341 3.9627 3.54335 3.54281C3.96325 3.12286 4.36299 2.86283 4.92312 2.64514C5.34597 2.4808 5.98136 2.28531 7.15135 2.23196C8.4167 2.17423 8.79625 2.16199 12.0004 2.16199V2.16199Z" fill="black" />
                  </g>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9992 15.9987C9.79005 15.9987 7.9992 14.2079 7.9992 11.9987C7.9992 9.78955 9.79005 7.9987 11.9992 7.9987C14.2083 7.9987 15.9992 9.78955 15.9992 11.9987C15.9992 14.2079 14.2083 15.9987 11.9992 15.9987ZM12.0001 5.83759C8.59676 5.83759 5.83789 8.59646 5.83789 11.9998C5.83789 15.403 8.59676 18.1619 12.0001 18.1619C15.4033 18.1619 18.1622 15.403 18.1622 11.9998C18.1622 8.59646 15.4033 5.83759 12.0001 5.83759V5.83759Z" fill="black" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8458 5.59426C19.8458 6.38956 19.2011 7.03424 18.4058 7.03424C17.6105 7.03424 16.9658 6.38956 16.9658 5.59426C16.9658 4.79896 17.6105 4.15424 18.4058 4.15424C19.2011 4.15424 19.8458 4.79896 19.8458 5.59426" fill="black" />
                </svg>
              </a>
            </div>
            <div className="customLand2-navItem">
              <svg width="68" height="20" viewBox="0 0 68 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.94152 0.0119068C4.4538 0.0119068 0 4.48477 0 9.99597C0 15.5072 4.4538 19.98 9.94152 19.98C15.4292 19.98 19.883 15.5072 19.883 9.99597C19.883 4.48477 15.4292 0.0119068 9.94152 0.0119068ZM9.94152 14.389C7.53567 14.389 5.56725 12.4121 5.56725 9.99597C5.56725 7.57983 7.53567 5.60298 9.94152 5.60298C12.3474 5.60298 14.3158 7.57983 14.3158 9.99597C14.3158 12.4121 12.3474 14.389 9.94152 14.389ZM58.6351 4.964C59.8281 3.98556 60.007 2.22837 59.0327 1.03028C58.0585 -0.167806 56.3088 -0.347519 55.1158 0.630919L48.7731 5.8426C48.5146 6.06225 48.117 5.86257 48.117 5.54308V2.88732C48.117 1.38971 46.9637 0.0917793 45.4725 0.0119068C43.8819 -0.0679657 42.5497 1.20999 42.5497 2.80744V17.1046C42.5497 18.6022 43.7029 19.9002 45.1942 19.98C46.7848 20.0599 48.117 18.7819 48.117 17.1845V14.4489C48.117 14.1094 48.5146 13.9297 48.7731 14.1493L55.1158 19.361C55.6328 19.7804 56.2491 20 56.8854 20C57.7006 20 58.4959 19.6406 59.0327 18.9816C60.007 17.7835 59.8281 16.0263 58.6351 15.0479L53.2667 10.6349C52.869 10.3155 52.869 9.71642 53.2667 9.39692L58.6351 4.964ZM65.2164 0.0119068C63.6854 0.0119068 62.4328 1.2699 62.4328 2.80744V17.1845C62.4328 18.722 63.6854 19.98 65.2164 19.98C66.7474 19.98 68 18.722 68 17.1845V2.80744C68 1.2699 66.7474 0.0119068 65.2164 0.0119068ZM38.752 4.964C39.945 3.98556 40.124 2.22837 39.1497 1.03028C38.1754 -0.167806 36.4257 -0.347519 35.2327 0.630919L28.8901 5.8426C28.6316 6.06225 28.2339 5.86257 28.2339 5.54308V2.88732C28.2339 1.38971 27.0807 0.0917793 25.5895 0.0119068C23.9988 -0.0679657 22.6667 1.20999 22.6667 2.80744V17.1046C22.6667 18.6022 23.8199 19.9002 25.3111 19.98C26.9018 20.0599 28.2339 18.7819 28.2339 17.1845V14.4489C28.2339 14.1094 28.6316 13.9297 28.8901 14.1493L35.2327 19.361C35.7497 19.7804 36.3661 20 37.0023 20C37.8175 20 38.6129 19.6406 39.1497 18.9816C40.124 17.7835 39.945 16.0263 38.752 15.0479L33.3836 10.6349C32.986 10.3155 32.986 9.71642 33.3836 9.39692L38.752 4.964Z" fill="black" />
              </svg>
            </div>
            <div className="customLand2-navItem">
              <a href="/login" className="customLand2-navItem-full">Iniciar sesión</a>
              <a href="/login" className="customLand2-navItem-responsive">Iniciar sesión</a>
              {/* <a target="_blank" href="https://www.twitter.com/okkico/" className="customLand2-navItem-full">Updates</a>
              <a target="_blank" href="https://www.twitter.com/okkico/" className="customLand2-navItem-responsive">
                <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.31402 24C20.5027 24 26.6251 14.7638 26.6251 6.76772C26.6251 6.50787 26.6251 6.24803 26.6132 5.98819C27.7997 5.1378 28.8319 4.06299 29.6506 2.84646C28.5591 3.33071 27.3844 3.64961 26.1505 3.80315C27.4081 3.05906 28.3692 1.86614 28.8319 0.448819C27.6573 1.14567 26.3522 1.64173 24.964 1.91339C23.8486 0.732283 22.2706 0 20.5264 0C17.1687 0 14.4397 2.71654 14.4397 6.05906C14.4397 6.5315 14.499 6.99213 14.5939 7.44095C9.53946 7.19291 5.05449 4.77165 2.05264 1.11024C1.53058 2.00787 1.23396 3.04724 1.23396 4.15748C1.23396 6.25984 2.31367 8.11417 3.93918 9.20079C2.94252 9.16535 2.00518 8.8937 1.1865 8.44488C1.1865 8.4685 1.1865 8.49213 1.1865 8.52756C1.1865 11.4567 3.2866 13.9134 6.06301 14.4685C5.55282 14.6102 5.01889 14.6811 4.46124 14.6811C4.06969 14.6811 3.69001 14.6457 3.3222 14.5748C4.09342 16.9843 6.34777 18.7323 9.00553 18.7795C6.91729 20.4094 4.29513 21.378 1.44753 21.378C0.961065 21.378 0.4746 21.3543 0 21.2953C2.68149 22.9961 5.88504 24 9.31402 24" fill="black" />
                </svg>
              </a> */}
            </div>
          </div>
        </Fade>
        <Fade>
          <div className={isToggled ? "customLand2-intro customLand2-introRed" : "customLand2-intro"} id="Intro" ref={introRef}>
            <Fade bottom opposite when={!isToggled} >
              <div className={isToggled ? "customLand2-intro__hide" : "customLand2-intro__text"}>
                <Fade duration={3000} delay={900}>
                  <img src={icons[activeIcon].icon} />
                </Fade>
                <Fade cascade duration={3000}>
                  <h1 className="customLand2-title onlyDesktop">
                    <Fade duration={3000} delay={100}>La plataforma </Fade>
                    <Fade duration={3000} delay={200}>para vender </Fade>
                    <Fade duration={3000} delay={300}>en línea </Fade>
                    <Fade duration={3000} delay={400}>sin comisiones </Fade>
                    <Fade duration={3000} delay={500}>ni intermediarios; </Fade><br />
                    <Fade duration={3000} delay={600}>El </Fade>
                    <Fade duration={3000} delay={700}>negocio </Fade>
                    <Fade duration={3000} delay={800}>es tuyo </Fade>
                  </h1>

                </Fade>
                <h1 className="customLand2-title onlyMobile">
                  <Fade duration={400}>
                    La plataforma para vender en línea
                    sin comisiones ni intermediarios;
                    El negocio es tuyo
                  </Fade>
                </h1>
                <Fade duration={3000} delay={900}>
                  <p className="customLand2-subtitle">
                    En Okki las personas encuentran lo que tú vendes
              </p>
                </Fade>

                <Fade duration={3000} delay={1000}>
                  <a onClick={toggleTrueFalse}>
                    <div
                      className="customLand2-buttonApply"
                      onMouseEnter={() => setShowText(!showText)}
                      onMouseLeave={() => setShowText(!showText)}
                    >
                      {showText ? (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.20029 13.2L12.0003 18L16.8003 13.2" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M12.0005 18L12.0005 6" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                      ) : (
                          <p>¡Regístrate!</p>
                        )}
                    </div>
                  </a>
                </Fade>
              </div>

            </Fade>
            <Fade top delay={1000}>
              <div
                className={isToggled ? "customLand2-nav showForm redNav" : "customLand2-nav customLand2-nav2"}
              >
                <div className="customLand2-navItemAlt">
                  <a target="_blank" href="https://www.instagram.com/okkico/" className="customLand2-navItem-full">Instagram</a>
                  <a target="_blank" href="https://www.instagram.com/okkico/" className="customLand2-navItem-responsive">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H24V23.9971H0V0Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C8.741 0 8.33234 0.0138139 7.05242 0.0722133C5.77516 0.13047 4.90283 0.333343 4.13954 0.630008C3.35044 0.936629 2.68123 1.34695 2.01406 2.01406C1.34695 2.68123 0.936629 3.35044 0.630008 4.13954C0.333343 4.90283 0.13047 5.77516 0.0722133 7.05242C0.0138139 8.33234 0 8.741 0 12C0 15.259 0.0138139 15.6677 0.0722133 16.9476C0.13047 18.2248 0.333343 19.0972 0.630008 19.8605C0.936629 20.6496 1.34695 21.3188 2.01406 21.9859C2.68123 22.6531 3.35044 23.0634 4.13954 23.37C4.90283 23.6667 5.77516 23.8695 7.05242 23.9278C8.33234 23.9862 8.741 24 12 24C15.259 24 15.6677 23.9862 16.9476 23.9278C18.2248 23.8695 19.0972 23.6667 19.8605 23.37C20.6496 23.0634 21.3188 22.6531 21.9859 21.9859C22.6531 21.3188 23.0634 20.6496 23.37 19.8605C23.6667 19.0972 23.8695 18.2248 23.9278 16.9476C23.9862 15.6677 24 15.259 24 12C24 8.741 23.9862 8.33234 23.9278 7.05242C23.8695 5.77516 23.6667 4.90283 23.37 4.13954C23.0634 3.35044 22.6531 2.68123 21.9859 2.01406C21.3188 1.34695 20.6496 0.936629 19.8605 0.630008C19.0972 0.333343 18.2248 0.13047 16.9476 0.0722133C15.6677 0.0138139 15.259 0 12 0ZM12.0004 2.16199C15.2045 2.16199 15.5841 2.17423 16.8494 2.23196C18.0194 2.28531 18.6548 2.4808 19.0776 2.64514C19.6378 2.86283 20.0375 3.12286 20.4574 3.54281C20.8773 3.9627 21.1374 4.36244 21.3551 4.92257C21.5194 5.34542 21.7149 5.98081 21.7682 7.1508C21.826 8.41615 21.8382 8.7957 21.8382 11.9999C21.8382 15.204 21.826 15.5835 21.7682 16.8489C21.7149 18.0188 21.5194 18.6542 21.3551 19.0771C21.1374 19.6372 20.8773 20.037 20.4574 20.4569C20.0375 20.8768 19.6378 21.1368 19.0776 21.3545C18.6548 21.5189 18.0194 21.7143 16.8494 21.7677C15.5842 21.8254 15.2047 21.8377 12.0004 21.8377C8.79601 21.8377 8.41656 21.8254 7.15135 21.7677C5.98136 21.7143 5.34597 21.5189 4.92312 21.3545C4.36299 21.1368 3.96325 20.8768 3.54335 20.4569C3.12346 20.037 2.86338 19.6372 2.64569 19.0771C2.48135 18.6542 2.28586 18.0188 2.23251 16.8489C2.17478 15.5835 2.16254 15.204 2.16254 11.9999C2.16254 8.7957 2.17478 8.41615 2.23251 7.1508C2.28586 5.98081 2.48135 5.34542 2.64569 4.92257C2.86338 4.36244 3.12341 3.9627 3.54335 3.54281C3.96325 3.12286 4.36299 2.86283 4.92312 2.64514C5.34597 2.4808 5.98136 2.28531 7.15135 2.23196C8.4167 2.17423 8.79625 2.16199 12.0004 2.16199V2.16199Z" fill="white" />
                      </g>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9992 15.9987C9.79005 15.9987 7.9992 14.2079 7.9992 11.9987C7.9992 9.78955 9.79005 7.9987 11.9992 7.9987C14.2083 7.9987 15.9992 9.78955 15.9992 11.9987C15.9992 14.2079 14.2083 15.9987 11.9992 15.9987ZM12.0001 5.83759C8.59676 5.83759 5.83789 8.59646 5.83789 11.9998C5.83789 15.403 8.59676 18.1619 12.0001 18.1619C15.4033 18.1619 18.1622 15.403 18.1622 11.9998C18.1622 8.59646 15.4033 5.83759 12.0001 5.83759V5.83759Z" fill="white" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8458 5.59426C19.8458 6.38956 19.2011 7.03424 18.4058 7.03424C17.6105 7.03424 16.9658 6.38956 16.9658 5.59426C16.9658 4.79896 17.6105 4.15424 18.4058 4.15424C19.2011 4.15424 19.8458 4.79896 19.8458 5.59426" fill="white" />
                    </svg>
                  </a>
                </div>
                <div className="customLand2-navItemAlt">
                  <svg onClick={toggleTrueFalse} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.1028 18.6949C26.5981 18.7697 27.8505 17.5734 27.8505 16.0781V13.5173C27.8505 13.1996 28.2243 13.0314 28.4673 13.237L34.4299 18.1155C34.9159 18.508 35.4953 18.7136 36.0935 18.7136C36.8598 18.7136 37.6075 18.3772 38.1121 17.7603C39.028 16.6388 38.8598 14.994 37.7383 14.0781L32.6916 9.94725C32.3178 9.64818 32.3178 9.08743 32.6916 8.78837L37.7383 4.65753C38.8598 3.74164 39.028 2.09678 38.1121 0.975286C37.1963 -0.146209 35.5514 -0.314433 34.4299 0.601454L28.4673 5.47996C28.2243 5.68557 27.8505 5.49865 27.8505 5.19958V2.69491C27.8505 1.29304 26.7664 0.07809 25.3645 0.00332367C23.8692 -0.0714427 22.6168 1.12482 22.6168 2.62015L22.6168 16.0033C22.6168 17.4052 23.7009 18.6201 25.1028 18.6949ZM14.8972 21.3117C13.4019 21.237 12.1495 22.4332 12.1495 23.9286V26.4893C12.1495 26.8071 11.7757 26.9753 11.5327 26.7697L5.57009 21.8912C5.08411 21.4986 4.50467 21.293 3.90654 21.293C3.14019 21.293 2.39252 21.6295 1.88785 22.2463C0.971963 23.3678 1.14019 25.0127 2.26168 25.9286L7.30841 30.0594C7.68224 30.3585 7.68224 30.9192 7.30841 31.2183L2.26168 35.3491C1.14019 36.265 0.971963 37.9099 1.88785 39.0314C2.80374 40.1529 4.4486 40.3211 5.57009 39.4052L11.5327 34.5267C11.7757 34.3211 12.1495 34.508 12.1495 34.8071V37.293C12.1495 38.6949 13.2336 39.9099 14.6355 39.9846C16.1308 40.0594 17.3832 38.8631 17.3832 37.3678L17.3832 23.9846C17.3832 22.6015 16.2991 21.3865 14.8972 21.3117ZM9.34579 0.00332367C4.18692 0.00332367 0 4.19024 0 9.34912C0 14.508 4.18692 18.6949 9.34579 18.6949C14.5047 18.6949 18.6916 14.508 18.6916 9.34912C18.6916 4.19024 14.5047 0.00332367 9.34579 0.00332367ZM9.34579 13.4613C7.08411 13.4613 5.23364 11.6108 5.23364 9.34912C5.23364 7.08743 7.08411 5.23697 9.34579 5.23697C11.6075 5.23697 13.4579 7.08743 13.4579 9.34912C13.4579 11.6108 11.6075 13.4613 9.34579 13.4613ZM37.3832 28.0407L23.9252 28.0407C22.486 28.0407 21.3084 29.2183 21.3084 30.6575C21.3084 32.0968 22.486 33.2743 23.9252 33.2743H37.3832C38.8224 33.2743 40 32.0968 40 30.6575C40 29.2183 38.8224 28.0407 37.3832 28.0407Z" fill="white" />
                  </svg>
                </div>
                <div className="customLand2-navItemAlt">
                  <a target="_blank" href="https://www.twitter.com/okkico/" className="customLand2-navItem-full">Updates</a>
                  <a target="_blank" href="https://www.twitter.com/okkico/" className="customLand2-navItem-responsive">
                    <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.31402 24C20.5027 24 26.6251 14.7638 26.6251 6.76772C26.6251 6.50787 26.6251 6.24803 26.6132 5.98819C27.7997 5.1378 28.8319 4.06299 29.6506 2.84646C28.5591 3.33071 27.3844 3.64961 26.1505 3.80315C27.4081 3.05906 28.3692 1.86614 28.8319 0.448819C27.6573 1.14567 26.3522 1.64173 24.964 1.91339C23.8486 0.732283 22.2706 0 20.5264 0C17.1687 0 14.4397 2.71654 14.4397 6.05906C14.4397 6.5315 14.499 6.99213 14.5939 7.44095C9.53946 7.19291 5.05449 4.77165 2.05264 1.11024C1.53058 2.00787 1.23396 3.04724 1.23396 4.15748C1.23396 6.25984 2.31367 8.11417 3.93918 9.20079C2.94252 9.16535 2.00518 8.8937 1.1865 8.44488C1.1865 8.4685 1.1865 8.49213 1.1865 8.52756C1.1865 11.4567 3.2866 13.9134 6.06301 14.4685C5.55282 14.6102 5.01889 14.6811 4.46124 14.6811C4.06969 14.6811 3.69001 14.6457 3.3222 14.5748C4.09342 16.9843 6.34777 18.7323 9.00553 18.7795C6.91729 20.4094 4.29513 21.378 1.44753 21.378C0.961065 21.378 0.4746 21.3543 0 21.2953C2.68149 22.9961 5.88504 24 9.31402 24" fill="white" />
                    </svg>
                  </a>
                </div>
              </div>
            </Fade>
            <Fade bottom when={isToggled}>

              <div
                className={isToggled ? "customLand2-form showForm" : "customLand2-form"}
                // className={`customLand2-form ${isToggled ? "showForm" : ""}`}
                id="Form" ref={formRef}>
                <section className="customForm">
                  <h5>
                    Ofrece tus servicios, vende tus productos.
                    Regístrate y crea tu perfil antes que los demás.<br />
                    -Lanzamiento Noviembre 2020-
                  </h5>
                  <br />
                  <div>
                    <label>Nombre completo</label>

                    <input
                      type="text"
                      class="input registerInput"
                      placeholder="Nombre completo"
                      onChange={(e) => setNombre(e.target.value)}
                    />
                    <div className="fieldError">{nombreError}</div>
                  </div>
                  <div>

                    <label>Correo electrónico</label>

                    <input
                      type="email"
                      class="input registerInput"
                      placeholder="Correo electrónico"
                      onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    />
                    <div className="fieldError">{emailError}</div>
                    <div className="fieldError">{postEmailError}</div>
                    <div className="fieldError"></div>
                    <div className="fieldError"></div>
                  </div>
                  <div className="radioList">
                    <label>Cuentanos que haces:</label>
                    <div>
                      {Tipos.map((tipo, index) => (
                        <label class="radioContainer">
                          {tipo.detalle == "Contratar"
                            ? "Doy un servicio"
                            : tipo.detalle == "Comer"
                              ? "Tengo un restaurante"
                              : tipo.detalle == "Comprar"
                                ? "Vendo un producto"
                                : null}
                          <input
                            type="radio"
                            name="category"
                            onChange={() => handleChange(tipo.id)}
                            value={tipo.id}
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                    <div className="fieldError">{tipo_idError}</div>
                  </div>
                  <div>
                    <label>Nombre de tu negocio</label>
                    <input
                      type="text"
                      class="input registerInput"
                      placeholder="Nombre de tu negocio"
                      onChange={(e) => setNombreNegocio(e.target.value)}
                    />
                    <div className="fieldError">{nombre_negocioError}</div>
                  </div>
                  <div>
                    <button onClick={handleSubmit} className="button" style={{ display: "block" }}>
                      Solicitar acceso
             </button>
                  </div>
                </section>
              </div>
            </Fade>
            <div className="customLand2-footerAlt">
              <ul>
                {isToggled ? <li className="customLand2-footer">Okki es un producto de <a target="_blank" href="https://www.lagggom.com/">Lagom Startup Studio®</a></li>
                  : <li>*Sin letras pequeñas. Completamente GRATIS</li>}
              </ul>
            </div>
          </div>
        </Fade>

        <Element name="myScrollToElement" id="myScrollToElement">


        </Element>


      </div>

    </div>
  );
}

export default Julio;
